import styled from 'styled-components'
export const Logo = styled.img`
    flex: 1;
    object-fit: contain;
    width: 50%;
`

export const LoginCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 40%;
    height: 70%;
    padding: 20px;
    gap: 10px;
    background-color: #fff;
    border-radius: 20px;
    max-width: 430px;
    max-height: 690px;
    ::before {
        content: '';
        top: 0;
        left: 0;
        width: 40%;
        border-radius: 20px;
        height: 15px;
        background-color: #111;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: 90%;
    }
`

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background-color: #111;
`

export const Button = styled.button`
    background-color: #ef4781;
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    width: 100%;
    height: 10%;
    min-height: calc(2.5rem);
    &:hover {
        background-color: #ef4781;
        opacity: 0.8;
    }
`

export const EmailPasswordContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    width: 100%;
`

export const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    gap: 20px;
`
